<template>
  <div>
    <p class="cm-mg-p-wzd">2.1 {{ $t('pqr.client_location_info') }}</p>
    <hr />
    <select-address
      @showHideLoading="showHideLoading"
      @onChange="handleChangeSelected"
    />
  </div>
</template>
<script>
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';

import store from '@/store';

export default {
  data() {
    return {
      model: {
        address: null,
        country: null,
        city: null,
        state: null,
      },
    };
  },

  mixins: [MixinPermissions, mixinMasters],

  methods: {
    validate() {
      return this.$validator
        .validateAll()
        .then((response) => {
          this.$emit('on-validated', response, { ...this.model });
          return response;
        })
        .then(() => {
          return store.dispatch(
            'utils/validationInputsRequired',
            '-second-step'
          );
        });
    },

    handleChangeSelected(data) {
      this.$set(this.model, data.name, data.selects);
    },
  },
};
</script>
